import React, { useCallback, useState } from 'react'
import styled, { createGlobalStyle } from 'styled-components'
import LogoIcon from 'images/header/magic-logo-mobile.svg'
import HambIcon from 'images/magic/hamb-icon.svg'
import CloseIcon from 'images/magic/close-icon.svg'
import mediaQuery from 'styles/mediaQuery'
import GetStartedButton from 'components/magic/GetStartedButton'
import colors from 'styles/colors'
import { purpleOutlineButtonStyle } from 'components/magic/styled'
import NavButtons from './NavButtons'
import Navigation from './Navigation'

const MenuWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1002;
  display: none;
  color: ${colors.white};

  ${mediaQuery.mobile} {
    display: block;
  }
`

const ContentWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1001;
  display: ${({ isVisible }) => (isVisible ? 'flex' : 'none')};
  background-color: ${colors.black};
  padding-top: 80px;
  flex-direction: column;

  ${mediaQuery.bigTabletMin} {
    display: none;
  }
`

const HeadRow = styled.div`
  position: relative;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  width: 100%;
  background-color: ${colors.black};
`

const Logo = styled(LogoIcon)`
  width: 48px;
  height: 48px;
`

const GetStarted = styled(GetStartedButton)`
  margin-right: 8px;
  padding: 12px 16px;
`

const ToggleButton = styled.button`
  ${purpleOutlineButtonStyle};
  padding: 0;
  width: 40px;
  height: 40px;
  position: relative;

  & svg {
    width: 20px;
    height: 20px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
`

const HeadButtons = styled.span`
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  justify-content: flex-end;
`

const BodyLock = createGlobalStyle`
  body {
    overflow: hidden;
  }
`

const MobileHeader = ({ darkTheme, isFixed }) => {
  const [isVisible, setVisible] = useState(false)

  const toggleMenu = useCallback(() => {
    setVisible(!isVisible)
  }, [isVisible, setVisible])

  return (
    <>
      {isVisible && <BodyLock />}
      <MenuWrapper dark={darkTheme} isFixed={isFixed}>
        <HeadRow>
          <Logo />
          <HeadButtons>
            {!isVisible && <GetStarted />}
            <ToggleButton onClick={toggleMenu}>
              {isVisible ? <CloseIcon /> : <HambIcon />}
            </ToggleButton>
          </HeadButtons>
        </HeadRow>
      </MenuWrapper>
      <ContentWrapper isVisible={isVisible}>
        <Navigation />
        <NavButtons />
      </ContentWrapper>
    </>
  )
}

export default MobileHeader
